/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { ICreateSceneCard, ISceneCard } from '../interfaces/scene-card';

export class SceneCardService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getSceneCardById(id: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING.GET_SCENE_CARDS,
					null,
					{ reqPathParam: id },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addSceneCard(newSceneCardData: ISceneCard) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.CREATE_SCENE_CARD,
					this.formatSceneCardReqData(newSceneCardData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateSceneCard(sceneTagToUpdateData: ISceneCard) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.UPDATE_SCENE_CARD,
					this.formatSceneCardReqData(sceneTagToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getSceneCards(page: number, { searchKey = '' }: { searchKey: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING.GET_SCENE_CARDS,
					{},
					{
						pathParams: { page: page || 1, searchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	searchSceneCardsAutoComplete({
		searchKey,
		withDetails = false,
	}: {
		searchKey: string;
		withDetails?: boolean;
	}) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.SEARCH_SCENE_CARDS,
					{},
					{
						pathParams: {
							searchKey,
							withDetails,
						},
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	deleteSceneCard(id: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().SCENE_MATCHING.DELETE_SCENE_CARD,
			null,
			{ reqPathParam: id },
		);
	}

	private formatSceneCardReqData({
		id,
		name,
		image,
		locatedTags,
	}: ISceneCard): ICreateSceneCard {
		return {
			...(id ? { id } : {}),
			name,
			imageId: image.id,
			locatedTags: locatedTags.map(locatedTag => ({
				...(locatedTag.id ? { id: locatedTag.id } : {}),
				imageAreaRectCoordinates: locatedTag.imageAreaRectCoordinates,
				sceneTagId: locatedTag.sceneTag.id,
			})),
		};
	}
}
